import { createIcon } from '@chakra-ui/react';

export const Benefit3 = createIcon({
  displayName: `Benefit3`,
  viewBox: `0 0 57.709 50.555`,
  path: [
    <g key="1" transform="translate(16.309)">
      <path
        d="M2949.271,1155.65a1.784,1.784,0,0,1,1.69.928c.983,2.077.738,6.5-4.354,14.484h2.6a13.013,13.013,0,0,1,13.134,12.458,12.853,12.853,0,0,1-13.041,13.1h-16.872a1.9,1.9,0,0,1-1.9-1.9v-21.763a1.9,1.9,0,0,1,1.9-1.9c2.467-.8,10.128-1.76,14.731-14.15a2.215,2.215,0,0,1,2.109-1.262m0-4.792h0a6.976,6.976,0,0,0-6.6,4.385c-3.318,8.93-8.114,10.251-10.69,10.96-.158.045-.31.086-.452.128a6.7,6.7,0,0,0-5.788,6.629v21.763a6.7,6.7,0,0,0,6.69,6.69H2949.3a17.841,17.841,0,0,0,12.883-5.383,17.332,17.332,0,0,0,4.949-12.626,17.753,17.753,0,0,0-12.881-16.415c2.2-5.085,2.554-9.259,1.038-12.461a6.535,6.535,0,0,0-6.019-3.669Z"
        transform="translate(-2925.741 -1150.858)"
        fill="currentColor"
      />
    </g>,
    <g key="2" transform="translate(0 17.825)">
      <path
        d="M2922.12,1193.167a6.6,6.6,0,0,1-6.589-6.59v-17.971a6.589,6.589,0,1,1,13.178,0v17.971A6.6,6.6,0,0,1,2922.12,1193.167Zm0-26.357a1.822,1.822,0,0,0-1.8,1.8v17.971a1.8,1.8,0,1,0,3.594,0v-17.971A1.823,1.823,0,0,0,2922.12,1166.809Z"
        transform="translate(-2915.531 -1162.017)"
        fill="currentColor"
      />
    </g>,
  ],
});
